module.exports.firebaseConfig = {
  apiKey: 'AIzaSyBTUz11sCAlyGSN9aBNNnnTKVUMQeBfJ7M',
  authDomain: 'forwardchessbackend.firebaseapp.com',
  databaseURL: 'https://forwardchessbackend.firebaseio.com',
  projectId: 'forwardchessbackend',
  storageBucket: 'forwardchessbackend.appspot.com',
  messagingSenderId: '10752173124',
  appId: '1:10752173124:web:29e3c08dfe5d6738fa8811',
  measurementId: 'G-6MLV3789HV',
}

module.exports.baseURL = 'https://api-v1.forwardchess.com'
//module.exports.baseURL = 'http://localhost:8080'
module.exports.supportURL = 'https://support-api.forwardchess.com'
